import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as actions from '../../actions';
import PropTypes from 'prop-types';
import { Radio } from 'antd';
import { StyledTable, StyledTd } from './custom-styled-components/_MyCustomSC';
import {
  FORM_DELIVERY_AMAZON_DEFAULT_BOX_SELECTION,
  FORM_DELIVERY_AMAZON_DEFAULT_PALLET_SELECTION,
} from '../../envVariables';

const MY_SUPPLIER_ME = 'My Supplier/Me';
const PRIME_FREIGHT = 'Prime Freight';
const NOT_APPLICABLE = 'Not Applicable';

/**
 * @component
 * @category Form Page
 * @subcategory Delivery
 * @name AmazonBoxPallet
 * @description Amazon mode box/pallet selection UI on delivery section
 * <br> <br>
 * **Example**
 * ```js
 *
 *<AmazonBoxPallet  />
 * ```
 */
class AmazonBoxPallet extends Component {
  state = {};

  componentDidMount = () => {};

  componentWillMount = () => {
    //Delivery destination location type, amazon default radio box/pallet selection
    let boxSelection = Number(FORM_DELIVERY_AMAZON_DEFAULT_BOX_SELECTION);

    if (boxSelection === 1) {
      boxSelection = MY_SUPPLIER_ME;
    } else if (boxSelection === 2) {
      boxSelection = PRIME_FREIGHT;
    } else {
      boxSelection = undefined;
    }

    let palletSelection = Number(FORM_DELIVERY_AMAZON_DEFAULT_PALLET_SELECTION);

    if (palletSelection === 1) {
      palletSelection = MY_SUPPLIER_ME;
    } else if (palletSelection === 2) {
      palletSelection = PRIME_FREIGHT;
    } else if (palletSelection === 3) {
      palletSelection = NOT_APPLICABLE;
    } else {
      palletSelection = undefined;
    }

    this.props.saveDeliveryAmazonData({
      boxSelection,
      palletSelection,
    });
  };

  /**
   * @description when box radio group is changed, this method is invoked
   * <br> <br>
   * **onBoxRadioChange(e) -> {void}**
   * <br><br>
   * **Parameters:**
   * | Name          | Type          | Description  |
   * | :------------ |:------------- | :------------|
   * | e             | Event         | box radio group onchange event |

   * Returns: Type: void
   */
  onBoxRadioChange = (e) => {
    this.props.saveDeliveryAmazonData({ boxSelection: e.target.value });
  };

  /**
   * @description when pallet radio group is changed, this method is invoked
   * <br> <br>
   * **onPalletRadioChange(e) -> {void}**
   * <br><br>
   * **Parameters:**
   * | Name          | Type          | Description  |
   * | :------------ |:------------- | :------------|
   * | e             | Event         | pallet radio group onchange event |

   * Returns: Type: void
   */
  onPalletRadioChange = (e) => {
    this.props.saveDeliveryAmazonData({ palletSelection: e.target.value });
  };

  render() {
    const { boxSelection, palletSelection } = this.props;

    return (
      <>
        <StyledTable style={{ width: 'auto', marginTop: '15px' }}>
          <tbody>
            {/* table header */}
            <tr>
              <th>
                <span style={{ fontWeight: 600 }}>
                  Amazon FBA Packing Requirements
                </span>
              </th>
            </tr>
            {/* table first row data */}
            <tr>
              <StyledTd
                style={{
                  width: '25%',
                  display: 'inline-block',
                  background: '#fafbfc',
                }}
              >
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                  }}
                >
                  <img
                    width="80px"
                    height="80px"
                    src={require('../../assets/amazon-mode/box.png')}
                    alt="box logo"
                  />
                  <span
                    style={{
                      fontSize: '11px',
                      marginTop: '16px',
                      textAlign: 'center',
                      fontWeight: 'bold',
                    }}
                  >
                    All boxes must have an Amazon label attached
                  </span>
                </div>
              </StyledTd>
              <StyledTd
                style={{
                  display: 'inline-block',
                  width: '75%',
                }}
              >
                <div>
                  {/* header */}
                  <div
                    style={{
                      fontSize: '14px',
                      fontWeight: 'bold',
                    }}
                  >
                    Who is labeling your boxes?
                  </div>

                  {/* radio btns */}
                  <Radio.Group
                    onChange={this.onBoxRadioChange}
                    value={boxSelection}
                    style={{
                      display: 'flex',
                      justifyContent: 'start',
                      alignItems: 'center',
                      marginTop: '12px',
                      // flexWrap: 'wrap',
                    }}
                    className="testR1"
                  >
                    <Radio
                      value={MY_SUPPLIER_ME}
                      style={{
                        ...radioBtnStyle,
                      }}
                      className="testR1"
                    >
                      My Supplier/Me
                    </Radio>
                    <Radio value={PRIME_FREIGHT} style={{ ...radioBtnStyle }}>
                      Prime Freight
                    </Radio>
                  </Radio.Group>
                </div>
              </StyledTd>
            </tr>

            {/* table second row data */}
            <tr>
              <StyledTd
                style={{
                  width: '25%',
                  display: 'inline-block',
                  background: '#fafbfc',
                  marginTop: '12px',
                }}
              >
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                  }}
                >
                  <img
                    width="80px"
                    height="80px"
                    src={require('../../assets/amazon-mode/pallet.png')}
                    alt="pallet logo"
                  />
                  <span
                    style={{
                      fontSize: '11px',
                      marginTop: '16px',
                      textAlign: 'center',
                      fontWeight: 'bold',
                    }}
                  >
                    Most shipments must arrive on labeled pallets
                  </span>
                </div>
              </StyledTd>

              <StyledTd
                style={{
                  width: '75%',
                  display: 'inline-block',
                  marginTop: '12px',
                }}
              >
                <div>
                  {/* header */}
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                      justifyContent: 'start',
                      alignItems: 'start',
                    }}
                  >
                    <span
                      style={{
                        fontSize: '14px',
                        textAlign: 'center',
                        fontWeight: 'bold',
                      }}
                    >
                      Who is placing your boxes on pallets?
                    </span>
                    <span
                      style={{
                        fontSize: '11px',
                        textAlign: 'center',
                        fontStyle: 'italic',
                        marginTop: '8px',
                      }}
                    >
                      Not applicable for UPS delivery to Amazon
                    </span>
                  </div>

                  {/* radio btns */}
                  <Radio.Group
                    onChange={this.onPalletRadioChange}
                    value={palletSelection}
                    style={{
                      display: 'flex',
                      justifyContent: 'start',
                      alignItems: 'center',
                      marginTop: '12px',
                      // flexWrap: 'wrap',
                    }}
                    className="testR1"
                  >
                    <Radio
                      value={MY_SUPPLIER_ME}
                      style={{
                        ...radioBtnStyle,
                      }}
                      className="testR1"
                    >
                      My Supplier/Me
                    </Radio>
                    <Radio value={PRIME_FREIGHT} style={{ ...radioBtnStyle }}>
                      Prime Freight
                    </Radio>
                    <Radio value={NOT_APPLICABLE} style={{ ...radioBtnStyle }}>
                      Not Applicable
                    </Radio>
                  </Radio.Group>
                </div>
              </StyledTd>
            </tr>
          </tbody>
        </StyledTable>
      </>
    );
  }
}

AmazonBoxPallet.propTypes = {
  /**
   *  Amazon radio box selection
   */
  boxSelection: PropTypes.number,

  /**
   * Amazon radio pallet selection
   */
  palletSelection: PropTypes.number,
};

const mapStateToProps = (state) => {
  return {
    boxSelection: state.form.delivery.amazonMode.boxSelection,
    palletSelection: state.form.delivery.amazonMode.palletSelection,
  };
};

export default connect(mapStateToProps, actions)(AmazonBoxPallet);

const radioBtnStyle = {
  border: '1px solid #bbc',
  borderRadius: '8px',
  width: '145px',
  height: '50px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  fontWeight: 'bolder',
  fontSize: '12px',
};
